// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';

window.$ = $;


$(() => {

  var MAX_CHAR = 140;

  let $name = $('.contribution-form__name input'),
    $email = $('.contribution-form__email input'),
    $message = $('.contribution-form__message textarea'),
    $form = $('#contributionForm'),
    $mainWrapper = $('.contribution-form'),
    $captcha = $('.contribution-form__captcha-wrapper .g-recaptcha'),
    $formsuccessbuttonblock = $('.contribution-form__submit-success'),
    $uploadClear = $('.contribution-form__upload-clear'),
    $uploadInput = $('.contribution-form__image-upload input'),
    $uploadButton = $('.contribution-form__image-upload button');


  const postEndpoint = $form.attr('action'),
    successMsg = $mainWrapper.data('success'),
    failureMsg = $mainWrapper.data('failure');


  window.imageFile = {};


  let allValidationFunctions = [
    validateName,
    validateEmail,
    validateMessage,
    validateAllImages,
    validateCaptcha
  ];


  // helper functions

  // Event Handlers =============================================================
  $form.on('submit', function (e) {
    let isAllValidated = checkAllValidation(),
      formValues = $(this).serializeArray();

    if (!isAllValidated) {
      //Prevent form from submitting if any field is invalid
      e.preventDefault();


      let $firstError = $('.field-error').first();
      let $parent = $firstError.closest('.contribution-form__form-group');


      $([document.documentElement, document.body]).animate({
        scrollTop: $parent.offset().top
      }, 1000);


    }
    else {
      e.preventDefault();

      // console.log('see all submitted values', $(this).serializeArray());

      //Add a div cover to protect submit button from being abused while form takes time to submit
      $formsuccessbuttonblock.show().css('display', 'flex');

      postForm(formValues);
    }
  });


  //If upload image icon is clicked, simulate clicking the input instead
  $uploadButton.click(function () {
    $(this).siblings('label').find('input[type="file"]').click();
  });


  //File is uploaded
  $uploadInput.on('change', function (e) {

    //Removed any previous compressed data
    clearCompressed();

    let filesMeta = getFilesMeta($(this));

    //Add file details to the DOM
    displayFilesDetails($(this), filesMeta);

    //Only compress images if the files pass validation
    //If fail, error messages will be displayed instead
    if (validateAllImages($(this), filesMeta)) {
      for (let fileObj of filesMeta) {
        let index = filesMeta.indexOf(fileObj);

        compressImage(fileObj.imageFile, index);
      }
    }
  });


  $uploadClear.on('click', function () {
    let $currentUpload = $(this).closest('.contribution-form__image-upload'),
      $currentUploadInput = $currentUpload.find('input');

    //1. Clear file input value
    $currentUploadInput.val('');

    //2. Removed any previous compressed data
    clearCompressed();

    //3. Clear file details display
    $currentUpload.find('.contribution-form__upload-text').text('Upload Image');

    //4. Remove existing validation
    let filesMeta = getFilesMeta($currentUploadInput);
    validateAllImages($currentUploadInput, filesMeta);

    //5. Hide this trash icon
    $(this).removeClass('show');
  });


  $message.on('change', function () {
    validateMessage();


  });

  $name.on('change', function () {
    validateName();
  });

  $email.on('change', function () {
    validateEmail();
  });


  $message.on('keyup', function (e) {
    var $this = $(e.target),
      $charCount = $('.charcount'),
      len = $this.val().length;

    if (e.which < 0x20 || len < MAX_CHAR) {
      var char = MAX_CHAR - len;
      $charCount.text(len + '/' + MAX_CHAR);
      $charCount.removeClass('max');
      return;
    }

    if (len == MAX_CHAR) {
      e.preventDefault();
      $charCount.text('140/' + MAX_CHAR);
      $charCount.addClass('max');
    }
    else if (len > MAX_CHAR) {
      $this.val($this.val().substring(0, MAX_CHAR));
      $charCount.text('140/' + MAX_CHAR);
      $charCount.addClass('max');
    }
  });


  //Validations ===============================================================
  window.onCaptchaSubmit = function () {
    validateCaptcha();
  };


  function postForm(formValues) {
    $.ajax({
      method: 'POST',
      url: postEndpoint,
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(formValues)
    })
      .done(function (response) {
        $form.remove();
        if (response.status && response.status === 'success') {
          console.log('submission successful!');
          $mainWrapper.append(`<h3 class="api-message success">${successMsg}</h3>`);
        }
        else {
          console.log('submission failure without message');
          $mainWrapper.append(`<h3 class="api-message fail">${failureMsg}</h3>`);
        }
      })
      .fail(function (err) {
        console.log('submission failure with bad status code');
        console.log(err);

        $form.remove();
        $mainWrapper.append(`<h3 class="api-message fail">${failureMsg}</h3>`);
      });
  }

  function validateCaptcha() {
    let formValues = $form.serializeArray(),
      errorMessage = 'Please complete Google Captcha';

    let captchaField = {};
    formValues.forEach(function (keyValue) {
      if (keyValue.name === 'g-recaptcha-response') {
        captchaField = keyValue;
      }
    });

    if (captchaField.value) {
      clearMessage($captcha);
      return true;
    }
    setErrorMessage($captcha, errorMessage);
  }
  function checkAllValidation() {
    let isAllValidated = true;
    //Run through all validation functions to display each error if fail
    allValidationFunctions.forEach(function (validation) {
      if (!validation()) {
        //Return false if one or more fields are invalid
        isAllValidated = false;
      }
    });
    return isAllValidated;
  }

  function validateMessage() {
    let value = $message.val();
    let errorMessage = 'Please fill in description.';

    //Pass validation if name input is more than 2 characters
    if (value.length > 2) {
      clearMessage($message);
      return true;
    }
    setErrorMessage($message, errorMessage);
  }


  function validateAllImages($thisUploadInput = $uploadInput, filesMeta = getFilesMeta($uploadInput)) {

    let $ele = $thisUploadInput
      .closest('.contribution-form__image-upload')
      .find('button'),
      isAllImagesValidated = true,
      errorMessages = '';

    //Exit if no file uploaded
    if (!filesMeta || filesMeta.length === 0) {
      clearMessage($ele);
      return true;
    }

    let notImageFiles = filesMeta.filter(
      fileObj => {
        return !fileObj.imageFile.type.match(/(jpg|jpeg|png)/i);
      }
    );


    //Clear previous message first
    clearMessage($ele);

    //check each file is img type
    if (notImageFiles.length > 0) {
      isAllImagesValidated = false;

      notImageFiles.forEach(fileObj => {
        errorMessages += `<span class="contribution-form__file-error">${fileObj.imageFile.name} is not an image file type</span>`;
      });
    }

    //Check if total number of files is not more than 5
    if (filesMeta.length > 5) {
      isAllImagesValidated = false;
      errorMessages += `<span class="contribution-form__file-error">${filesMeta.length} files have been selected. Only a maximum of 5 image files can be uploaded.</span>`;
    }

    if (isAllImagesValidated) {
      clearMessage($ele);
      return true;
    }
    else {
      setErrorMessage(
        $ele,
        `<span class="contribution-form__error-wrapper">${errorMessages}</span>`
      );
    }
  }

  function validateName() {
    let nameInput = $name.val();
    let errorMessage = 'Name should be more than 2 characters long.';

    //Pass validation if name input is more than 2 characters
    if (nameInput.length > 2) {
      clearMessage($name);
      return true;
    }
    setErrorMessage($name, errorMessage);
  }

  //Pass if input is in email format
  function validateEmail() {
    let emailInput = $email.val();
    let errorMessage = 'Invalid email address.';
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(emailInput)) {
      clearMessage($email);
      return true;
    }

    setErrorMessage($email, errorMessage);
  }

  //Helper Functions ==========================================================

  //compress uploaded images down to max 440px width each
  //Attach compressed image as data uri format in a hidden input, then append to form
  //Hidden input class is .contribution-form__compressed-image
  function compressImage(imageFile, index) {
    const fileName = imageFile.name;
    const reader = new FileReader();
    reader.readAsDataURL(imageFile);
    reader.onload = event => {
      const img = new Image();
      img.src = event.target.result;
      (img.onload = () => {
        //Maintain aspect ratio of image while compressing
        //Max 440px width
        const width = 540;
        const scaleFactor = width / img.width;
        const elem = document.createElement('canvas');
        elem.width = width;
        elem.height = img.height * scaleFactor;
        const ctx = elem.getContext('2d');
        // img.width and img.height will contain the original dimensions
        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);

        var compressed = ctx.canvas.toDataURL('image/jpeg', 1.0);

        //Append to DOM
        appendCompressed(compressed, index, fileName);
      }),
        (reader.onerror = error => console.log(error));
    };
  }

  function appendCompressed(dataURI, index, fileName) {
    console.log(dataURI);
    //Attach compressed image as data uri format in a hidden input, then append to form
    $form.append(
      `<input type="hidden" class="contribution-form__compressed-image" name="image_upload[${index}]" value="${dataURI}" /><input type="hidden" class="contribution-form__compressed-alt" name="image_upload_alt[${index}]" value="${fileName}" />`
    );
  }

  function clearCompressed() {
    //Removed any previous compressed data
    $('#contributionForm .contribution-form__compressed-image').remove();
    $('#contributionForm .contribution-form__compressed-alt').remove();
  }


  //Get all metadata from file inputs
  function getFilesMeta($thisUploadInput) {
    let imageFiles = $thisUploadInput.prop('files'),
      filesMeta = [];

    for (let indexKey in imageFiles) {
      //imageFiles is an obj with index as keys, can be length key value also
      // console.log('imageFiles', imageFiles);

      if (imageFiles[indexKey].type) {
        let imageFile = imageFiles[indexKey],
          size = imageFile.size / 1000 || 0;
        size = parseInt(size, 10);

        filesMeta = [...filesMeta, { imageFile, size }];
      }
    }

    return filesMeta;
  }

  //Display file name and file size upon file input
  function displayFilesDetails($thisUploadInput, filesMeta) {
    let $thisUploadText = $thisUploadInput.prev('.contribution-form__upload-text'),
      $thisClearButton = $thisUploadInput.closest('.contribution-form__image-upload').find('.contribution-form__upload-clear');


    let combinedText = filesMeta
      .map(function (fileObj) {
        return `<span class="contribution-form__file-wrapper">${fileObj.imageFile.name}
			<span class="contribution-form__file-size">(${fileObj.size} KB)</span></span>`;
      })
      .join('');


    if (filesMeta.length === 0) {
      $thisUploadText.html('Upload Image');
      $thisClearButton.removeClass('show');


    }
    else {
      $thisClearButton.addClass('show');
      $thisUploadText.html(`<span class="contribution-form__uploaded-number">${filesMeta.length} file(s)</span> ${combinedText}`);
    }

  }

  //Add error/details message below the relevant input field
  function setErrorMessage($ele, message) {
    //Remove existing error message
    if ($ele.next().hasClass('field-error')) {
      clearMessage($ele);
    }
    //Add new error message
    $ele.after(
      `<span class="field-error"><span class="field-error__img-wrapper"><img src="../Cwp/assets/PTM/images/exclamation.svg" alt="exclamation icon"/></span>${message}</span>`
    );
  }

  //Clear message directly below the input field
  function clearMessage($ele) {
    $ele.next('.field-error').remove();
  }

  //typeahead match config
  function substringMatcher(strs) {
    return function findMatches(q, cb) {
      var matches, substrRegex;

      // an array that will be populated with substring matches
      matches = [];

      // regex used to determine if a string contains the substring `q`
      substrRegex = new RegExp(q, 'i');

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      $.each(strs, function (i, str) {
        if (substrRegex.test(str)) {
          matches.push(str);
        }
      });

      cb(matches);
    };
  }
});
